import { connect } from 'react-redux'
import GigButton from './GigButton'
import { openGigStartConfirmationModal, openGigEndConfirmationModal } from '../../dataStore/actions/ui/uiActions'

const mapStateToProps = state => ({
  status: state.ui.status
})

const mapDispatchToProps = dispatch => ({
  onClickStart: () => dispatch(openGigStartConfirmationModal()),
  onClickEnd: () => dispatch(openGigEndConfirmationModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(GigButton)
